<div
  class="container bg-white p-4 mb-4"
  style="
    border: solid 1px #eeeeeeee;
    border-radius: 10px;
    box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.05);
  "
>
  <div *ngIf="post">
    <!-- Header -->
    <div class="row pb-4">
      <div class="col-1 mr-4 mr-lg-0 mr-md-0">
        <img
          [src]="
            profilePicture
              ? profilePicture
              : 'assets/common/images/default-profile-picture.png'
          "
          class="mr-3 rounded-circle logo"
        />
      </div>

      <div class="col-9">
        <!-- account name -->
        <a
          class="pt-2 addFont"
          style="color: #1b101b !important; font-weight: bold"
          *ngIf="post?.appPost?.accountId"
          [routerLink]="['/app/main/account/view/', post?.appPost?.accountId]"
        >
          {{ post.appPost.accountName }}
        </a>

        <a class="pt-2 addFont" *ngIf="!post?.appPost?.accountId">
          {{ post.appPost.accountName }}
        </a>

        <!-- date line -->
        <h6 class="userName" *ngIf="!fromMarketplaceProfile">
          {{ "PostBy" | localize }},<b>{{ post.appPost.userName }}</b> ,
          {{ post.appPost.creationDatetime?.toString() | date : "mediumDate" }}
        </h6>

        <h6 class="userName" *ngIf="fromMarketplaceProfile">
          {{ "posted in :" | localize }}
          {{
            post.appPost.creationDatetime?.toString()
              | date : "h:mm a, dd-MM-yyyy"
          }}
        </h6>
      </div>

      <!-- Actions -->
      <div *ngIf="post.canEdit || isHost" class="text-right PositionRight pr-4">
        <div class="dropdown" dropdown>
          <button
            class="btn btn-secondary dropdown-toggle p-0"
            type="button"
            id="dropdownMenuButton"
            aria-haspopup="true"
            aria-expanded="false"
            dropdownToggle
          >
            <div class="three-dots"></div>
          </button>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" *dropdownMenu>
            <a class="dropdown-item" (click)="editPost()">
              <img
                src="assets/posts/Edit_ic.svg"
                class="mr-3"
                style="width: 15px"
              />
              {{ "Editpost" | localize }}
            </a>

            <a class="dropdown-item" (click)="deletePost()">
              <img
                src="assets/posts/Delete_ic.svg"
                class="mr-3"
                style="width: 15px"
              />
              {{ "RemovePost" | localize }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Body click wrapper -->
    <a
      [ngClass]="post.type == PostType.TEXT ? 'cursor-text' : 'pointer'"
      (click)="onshowViewPost()"
    >
      <!-- Description -->
      <div
        *ngIf="post.appPost.description && post.appPost.description != ''"
        class="row p-4 descriptionContainer pointer"
      >
        <h6 class="description">{{ post.appPost.description }}</h6>
      </div>

      <!-- MEDIA -->
      <div class="pb-2 pl-4 pointer pr-4 pt-4 row justify-content-center">
        <!--  IMAGES -->
        <div
          *ngIf="post.type === PostType.SINGLEIMAGE && post.attachmentsURLs?.length"
          class="media-wrap w-100"
        >
          <!--  EVENT special UI (same as old version) -->
          <ng-container
            *ngIf="isEventPost() && post.attachmentsURLs.length === 2; else normalGrid"
          >
            <div class="event-wrap">
              <!-- cover -->
              <img
                class="event-cover"
                [src]="attachmentBaseUrl + '/' + post.attachmentsURLs[1]"
                loading="lazy"
                (error)="onImgError($event)"
              />

              <!-- logo overlay -->
              <img
                class="event-logo"
                [src]="attachmentBaseUrl + '/' + post.attachmentsURLs[0]"
                loading="lazy"
                (error)="onImgError($event, true)"
              />
            </div>
          </ng-container>

          <!--  NORMAL posts (new grid UI) -->
          <ng-template #normalGrid>
            <div class="fb-grid" [ngClass]="'count-' + visibleImages.length">
              <ng-container *ngFor="let img of visibleImages; let i = index">
                <div class="cell" [ngClass]="'i' + (i + 1)">
                  <img
                    class="fb-img"
                    [src]="attachmentBaseUrl + '/' + img"
                    loading="lazy"
                    (error)="onImgError($event)"
                  />

                  <!-- overlay if > 5 -->
                  <div class="more-overlay" *ngIf="i === 4 && remainingCount > 0">
                    +{{ remainingCount }}
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>
        </div>

        <!-- Video -->
        <div
          *ngIf="post.type == PostType.SINGLEVIDEO || post.type == PostType.NEWSDIGEST"
          class="_video w-100"
        >
          <video
            (playing)="playVideo(post.attachmentsURLs[0], $event)"
            (click)="playVideo(post.attachmentsURLs[0], $event)"
            controls
            [attr.src]="
              attachmentBaseUrl + '/' + post.attachmentsURLs[0] | sanitizeurl
            "
            class="w-100 h-100"
          ></video>
        </div>
      </div>
    </a>

    <!-- Link preview for TEXT -->
    <div
      *ngIf="linkUrl && post.type == PostType.TEXT"
      (click)="InteractionsComponent.createView()"
    >
      <app-link-preview
        [url]="linkUrl"
        [title]="post?.urlTitle"
        [urlPreviewImage]="urlPreviewImage"
        [maxHeight]="'400px'"
      ></app-link-preview>
    </div>
  </div>

  <!-- Related Entity -->
  <div
  *ngIf="getAppEntityForViewDto"
  class="row  p-4 pointer viewContainer mb-5"
>
  <div class="col-8 col-sm-9">
      <h5>
          {{"LetsView" | localize }}
          {{ getAppEntityForViewDto.relatedEntityTypeCode | titlecase }} !
      </h5>
  </div>
  <div class="col-2">
      <button
          class="btn  _Btn pointer"
          (click)="viewRelatedEntity()"
      >
          {{"View" | localize }}
          {{ getAppEntityForViewDto.relatedEntityTypeCode | titlecase }}
      </button>
  </div>
</div>

  <!-- Interactions -->
  <app-interactions
    #InteractionsComponent
    [entityId]="post?.appPost?.appEntityId"
    [relatedEntityId]="post?.appPost?.appEntityId"
    [postCreatorUserId]="post?.appPost?.creatorUserId"
    [addNewThread]="addNewThread"
  ></app-interactions>
</div>